import IconButton from "@mui/material/IconButton";
import { Icon } from "components/Icon/Icon";
import PropTypes from "prop-types";

const BinaryStateButton = ({
    state,
    onClick,
    trueStateIcon,
    falseStateIcon,
    trueStateColor,
    falseStateColor,
    disabled,
    className,
}) => (
    <IconButton
        disabled={disabled}
        onClick={onClick}
        color={state ? trueStateColor : falseStateColor}
        className={className}
    >
        <Icon icon={state ? trueStateIcon : falseStateIcon} />
    </IconButton>
);

BinaryStateButton.propTypes = {
    state: PropTypes.bool.isRequired,
    onClick: PropTypes.func,
    trueStateIcon: PropTypes.elementType.isRequired,
    falseStateIcon: PropTypes.elementType.isRequired,
    trueStateColor: PropTypes.string,
    falseStateColor: PropTypes.string,
    disabled: PropTypes.bool,
    className: PropTypes.string,
};

BinaryStateButton.defaultProps = {
    onClick: () => {},
    disabled: false,
    trueStateColor: "default",
    falseStateColor: "default",
    className: null,
};

export default BinaryStateButton;
